module.exports = __webpack_public_path__ + "img/users-gray.8808dd45.svg";